<script>
import Chart from 'chart.js';

export default {
  name: 'AnalyticsPageviewsReport',
  props: {
    colors: Array,
    data: Object,
    loading: Boolean
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      if (this.data && this.data.rows) {
        const rows = this.data.rows;
        const data = {
          labels: rows.map(row => this.$d(this.convertGADate(row[0]), 'short')),
          datasets: [
            {
              label: 'Visits',
              data: rows.map(row => row[2]),
              backgroundColor: this.colors[0],
              borderColor: 'white',
              borderWidth: 2
            },
            {
              label: 'Pageviews',
              data: rows.map(row => row[1]),
              backgroundColor: this.colors[1],
              borderColor: 'white',
              borderWidth: 2
            }
          ]
        };

        return data;
      }
    }
  },
  watch: {
    data() {
      this.updateChart();
    }
  },
  mounted() {
    this.chart = new Chart(this.$refs.chart, {
      type: 'line',
      options: {
        maintainAspectRatio: false,
        responsive: true,
        elements: {
          point: {
            radius: 4,
            hoverRadius: 5
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                beginAtZero: true,
                callback: value => value.toLocaleString()
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: tooltipItem => tooltipItem.yLabel.toLocaleString()
          }
        }
      }
    });
    this.updateChart();
  },
  methods: {
    // Converts a date like 20180822 to a date object
    convertGADate(string) {
      const year = string.slice(0, 4);
      const month = parseInt(string.slice(4, 6)) - 1;
      const day = string.slice(6, 8);
      return new Date(year, month, day);
    },

    // Updates and renders the chart
    updateChart() {
      if (this.chartData) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  }
};
</script>

<template>
  <div ref="chartContainer" v-loading="loading" class="pageviews-chart">
    <canvas ref="chart" />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.pageviews-chart {
  position: relative;
  height: 20rem;
  margin-bottom: 2rem;

  @include breakpoint('md-and-down') {
    height: 14rem;
  }
}
</style>
